

export const GoogleIcon = () => (
    <img className="custom-google-icon" src={require('../../google_icon.png')} height="18" alt="SVG as an image" />
);